
export function areaDevicesModal(area, sh_api) {
	console.log("areaDevicesModal", area);

	return Modals.create("area-devices-modal", {
		title: `<i class="ph ph-map-trifold normalize"></i> ${area.name}`,
		body: modal => {
			// const state = (script.state == "enabled") 
			// 	? "<span class='badge badge-success'>Enabled</span>"
			// 	: "<span class='badge badge-warning'>Disabled</span>"
			// 	
			return `
				<div class="loader"></div>
				<div class="devices-container">

				</div>
			`;
		},
		actions: modal => {
			const btnCancel = Helper.template.createElement("button", {
				class: "btn btn-primary"
			}, "Close");

			const btnRemove = Helper.template.createElement("button", {
				class: "btn btn-danger with-icon"
			}, `<i class="ph ph-trash"></i> Remove`);

			btnCancel.addEventListener("click", e => {
				modal.close();
			});

			return [ btnCancel, btnRemove ];
		},
		onready: modal => {
			const devicesContainer = modal.querySelector(".devices-container");
			const loader = modal.querySelector(".loader");

			sh_api.areas.devices(area.id, (err, data, meta) => {
				console.log("sh_api.areas.devices", data);

				function prepareDevicesData(data) {
					const preparedData = [];
					for(let device of data.devices) {
						device = Helper.unification.deviceFieldsUnification(device);

						const connectionState = device.connection_state == "active"
							? `<span class="badge badge-success">Online</span>`
							: `<span class="badge badge-warning">Offline</span>`;

						preparedData.push({
							deviceName: device.name,
							alias: device.alias,
							status: connectionState,
							ip: `<code class="code">${device.ip}</code>`,
							actions: `
								<button 
									class="btn btn-warning btn-small reboot-btn" 
									data-device-id="${device.id}" 
									data-device-name="${device.name}" 
									data-device-alias="${device.alias}" 
									type="button"
								>Reboot</button>
							`
						});
					}

					return preparedData;
				}

				const devices = prepareDevicesData(data.data);

				devicesContainer.innerHTML = Helper.template.table(
					"", 
					{
						deviceName: "Device name", 
						alias: "Device alias", 
						status: "Status", 
						ip: "IP", 
						actions: "Actions"
					},
					devices,
					`<span class="table-meta">Total: <span class="total">${devices.length}</span> devices</span>`
				);

				loader.remove();

				console.log("devices", devices);
			});
		}
	});
}